import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const WayTripRadios = ({roundTrip, setRoundTrip, translations}) => {
  const typeTrips = [
    {label: translations.oneWay},
    {label: translations.roundtrip}
  ];

  return (
    <div
      className="d-flex justify-content-center bg-white mt-4 mb-3 p-1 mx-auto rounded-pill cursor-pointer"
      style={{width: 'fit-content'}}
    >
      {typeTrips.map(({label}, index) => {
        const tripClass = classnames('font-bold py-2 px-5 rounded-pill', {
          'bg-primary': index === 0 ? !roundTrip : roundTrip
        });

        return (
          <span
            key={index}
            className={tripClass}
            onClick={() => setRoundTrip(index)}
          >
            {label}
          </span>
        );
      })}
    </div>
  );
};

WayTripRadios.propTypes = {
  roundTrip: PropTypes.bool.isRequired,
  setRoundTrip: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    roundtrip: PropTypes.string.isRequired,
    oneWay: PropTypes.string.isRequired
  })
};

export default WayTripRadios;
